
import React, { useState, useEffect } from 'react';
import { MainLayout } from "@shared/components/md-design-system/Layout/MainLayout";
import { UserDataForm } from '../components/UserDataForm';
import { useNavigation } from '@react-navigation/native';
import { useAuth } from 'app/auth/hooks/useAuth';
import { userApi } from '../api/userApi';
import { IPatientFormFields, IPatientData } from '../types/userFormTypes';
import { Loading } from "@shared/components/loading";

const PersonalData = () => {
    const navigation = useNavigation();
    const { user } = useAuth();
    const [patientData, setPatientData] = useState<IPatientData | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    // TECHDEBT
    // Issue: https://app.clickup.com/t/86c8fp9eg
    // Description: Direct API call without React Query - missing cache, retry logic, and proper loading states
    const fetchPatientData = async () => {
        try {
            setIsLoading(true);
            const data = await userApi.getPatientData();
            setPatientData(data);
        } catch (error) {
            setPatientData(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPatientData();
    }, []);

    const handleGoBack = () => {
        navigation.goBack();
    };

    const initialValues = {
        first_name: patientData?.first_name || user?.given_name || '',
        last_name: patientData?.last_name || user?.family_name || '',
        email: patientData?.email || user?.email || '',
        phone_country_code_prefix: patientData?.phone?.country_code_prefix || '+39',
        phone_number: patientData?.phone?.phone_number || '',
    };

    if (isLoading) {
        return (
            <MainLayout navigation={handleGoBack}>
                <Loading />
            </MainLayout>
        );
    }

    return (
        <MainLayout navigation={handleGoBack} scrollable={true}>
            <UserDataForm
                formType="personal_data"
                initialValues={initialValues}
                onDataRefresh={fetchPatientData}
            />
        </MainLayout>
    );
};

export default PersonalData;